export const GET_ACCOUNT_DETAILS_QUERY_KEY = 'accountDetails';
